export { default } from "./IntervalsTutorial";
